import { render, staticRenderFns } from "./supplierOffer-list.vue?vue&type=template&id=38e87273&"
import script from "./supplierOffer-list.vue?vue&type=script&lang=ts&"
export * from "./supplierOffer-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "supplierOffer-list.vue"
export default component.exports